import { withNamespaces } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

import Navigator from "src/components/Navigator";

import Tabs from "./tabs";
import UsersTab from "./tabs-contents/users";
import FunctionsTab from "./tabs-contents/functions";

const UserManagement = () => {
    const location = useLocation();

    const renderSelectedTabContent = () => {
        const searchParams = new URLSearchParams(location.search);

        switch (searchParams.get("tab")) {
            case "functions":
                return <FunctionsTab />;

            case "users":
            default:
                return <UsersTab />;
        }
    };

    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator
                            pageTitle="User Management"
                            breadCrumbs={[
                                { title: "SIP", link: "/" },
                                { title: "User Management", link: "#" },
                            ]}
                            translate={true}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col lg="12" className="mb-4">
                        <div className="details-content-wrapper bg-white">
                            <Tabs />

                            <Row>
                                <Col xl="12">{renderSelectedTabContent()}</Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default withNamespaces()(UserManagement);
